// extracted by mini-css-extract-plugin
module.exports = {"list":"CompanyLogoList_list__1zy6c","logo":"CompanyLogoList_logo__3frsQ"};